(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["army-select"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('army-select')) {
    class ArmySelect extends HTMLElement {
      connectedCallback() {
        this.current = null;
        this.onStage = null;
        this.target = null;
        this.busy = false;
        this.z = 1;
        this.enterSpeed = parseFloat(this.dataset.enterSpeed) || 1;
        this.exitSpeed = parseFloat(this.dataset.exitSpeed) || 1;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.hd = window.matchMedia('(min-width: 1000px)').matches && !(navigator.connection && navigator.connection.saveData);
        this.nameEl = this.querySelector('[data-army-name]');
        this.hintName = this.querySelector('[data-army-hint-name]');
        this.cta = this.querySelector('[data-army-cta]');
        this.tiles = [...this.querySelectorAll('button[data-army]')];
        this.notify = this.querySelector('[data-army-notify]');
        this.querySelectorAll('[data-army-soon]').forEach((tile) => tile.addEventListener('click', () => this.showNotify(tile)));
        if (this.notify) {
          this.notify.addEventListener('submit', () => this.sendNotify());
          this.restoreNotify();
        }

        this.tiles.forEach((tile) => {
          // mouse: hovering a tile deploys its army (short delay so sweeping across the grid doesn't fire them all)
          tile.addEventListener('pointerenter', (event) => {
            this.warm(tile.dataset.army, true);
            if (event.pointerType !== 'mouse') return;
            clearTimeout(this.hoverTimer);
            this.hoverTimer = setTimeout(() => this.select(tile.dataset.army), 120);
          });
          tile.addEventListener('pointerleave', () => clearTimeout(this.hoverTimer));
          tile.addEventListener('focus', () => this.warm(tile.dataset.army, true));
          // click / tap: deploys the army, or opens its collection when it is already the one on display
          tile.addEventListener('click', () => {
            clearTimeout(this.hoverTimer);
            if (this.target === tile.dataset.army) window.location.href = tile.dataset.link;
            else this.select(tile.dataset.army);
          });
        });

        // preload every animated army a little before the section scrolls into view
        this.observer = new IntersectionObserver(
          ([entry]) => {
            if (!entry.isIntersecting) return;
            this.observer.disconnect();
            this.tiles.forEach((tile) => this.warm(tile.dataset.army));
          },
          { rootMargin: '400px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      plate(name) {
        return this.querySelector(`[data-plate="${name}"]`);
      }

      clip(name) {
        return this.querySelector(`[data-clip="${name}"]`);
      }

      warm(army, priority = false) {
        ['still', 'empty'].forEach((kind) => {
          const img = this.plate(`${kind}-${army}`);
          if (img && !img.srcset) img.srcset = img.dataset.srcset;
        });
        ['enter', 'exit'].forEach((kind) => {
          const video = this.clip(`${kind}-${army}`);
          if (!video || video.src) return;
          video.preload = 'auto';
          video.src = this.hd ? video.dataset.hd : video.dataset.sd;
          if (priority) video.load();
        });
      }

      // locked army: no figure to deploy, the pick area becomes a "notify me" form instead of the CTA
      showNotify(tile) {
        if (!this.notify) return;
        this.querySelectorAll('[data-army-soon]').forEach((t) => t.setAttribute('aria-pressed', String(t === tile)));
        this.tiles.forEach((t) => t.setAttribute('aria-pressed', 'false'));
        this.target = null;
        this.style.setProperty('--army-accent', tile.dataset.color);
        if (this.hintName) this.hintName.textContent = tile.dataset.name;
        this.classList.add('is-picked');
        this.nameEl.textContent = '';
        this.cta.hidden = true;
        this.notify.dataset.army = tile.dataset.armySoon;
        this.notify.querySelector('[data-army-notify-tags]').value = `notify-${tile.dataset.armySoon},newsletter`;
        this.notify.querySelector('[data-army-notify-title]').textContent = (this.dataset.notifyTitle || '[army] are being forged').replace('[army]', tile.dataset.name);
        this.notify.hidden = false;
      }

      // native post (Shopify bot protection rejects background posts); the page comes back with ?customer_posted=true
      sendNotify() {
        try {
          sessionStorage.setItem('army-notify', this.notify.dataset.army);
        } catch (e) {}
      }

      restoreNotify() {
        let army = null;
        try {
          army = sessionStorage.getItem('army-notify');
          sessionStorage.removeItem('army-notify');
        } catch (e) {}
        if (!army || !/customer_posted=true/.test(window.location.search)) return;
        const tile = this.querySelector(`[data-army-soon="${army}"]`);
        if (!tile) return;
        this.showNotify(tile);
        this.notify.querySelector('.army__notify-row').hidden = true;
        this.notify.querySelector('[data-army-notify-done]').hidden = false;
        this.scrollIntoView({ block: 'center' });
      }

      select(army) {
        if (this.notify) this.notify.hidden = true;
        this.querySelectorAll('[data-army-soon]').forEach((t) => t.setAttribute('aria-pressed', 'false'));
        if (army === this.target) return;
        this.target = army;
        this.tiles.forEach((tile) => tile.setAttribute('aria-pressed', String(tile.dataset.army === army)));
        if (!this.busy) this.run();
      }

      // one transition at a time; a choice made meanwhile is played once the running one ends
      async run() {
        this.busy = true;
        while (this.target !== this.current) {
          const next = this.target;
          await this.transition(next);
          this.current = next;
        }
        this.busy = false;
      }

      // this.onStage = army whose figure is standing in the scene (null while the scene is empty)
      async transition(to) {
        const tile = this.tiles.find((t) => t.dataset.army === to);
        this.warm(to, true);
        this.style.setProperty('--army-accent', tile.dataset.color);
        this.nameEl.textContent = tile.dataset.name;
        if (this.hintName) this.hintName.textContent = tile.dataset.name;
        this.classList.add('is-picked');
        this.cta.href = tile.dataset.link;
        this.cta.hidden = false;

        if (this.reducedMotion) {
          await this.show(this.plate(`still-${to}`), true);
          this.onStage = to;
          return;
        }

        if (this.onStage) {
          const exit = this.clip(`exit-${this.onStage}`);
          await this.play(exit, null, false, this.exitSpeed);
          this.show(this.plate(`empty-${this.onStage}`), false);
          this.hide(exit);
          this.onStage = null;
        }

        // another army was picked meanwhile: skip this figure, go straight on
        if (this.target !== to) return;

        // the enter clip fades in over the previous scene: the new light colour comes with the figure
        tile.classList.add('is-loading');
        const enter = this.clip(`enter-${to}`);
        await this.play(enter, () => tile.classList.remove('is-loading'), true, this.enterSpeed);
        tile.classList.remove('is-loading');
        this.show(this.plate(`still-${to}`), false);
        this.hide(enter);
        this.onStage = to;
      }

      // put a layer on top; with fade it eases in, then everything under it is switched off
      show(el, fade) {
        return new Promise((resolve) => {
          if (!el) return resolve();
          el.classList.toggle('is-instant', !fade);
          el.style.zIndex = ++this.z;
          if (el.tagName === 'IMG' && !el.srcset && el.dataset.srcset) el.srcset = el.dataset.srcset;
          requestAnimationFrame(() => {
            el.classList.add('is-on');
            const done = () => {
              this.querySelectorAll('.army__plate.is-on').forEach((p) => p !== el && p.classList.remove('is-on'));
              resolve();
            };
            if (fade) setTimeout(done, 460);
            else done();
          });
        });
      }

      hide(el) {
        if (!el) return;
        el.classList.remove('is-fading');
        el.classList.add('is-instant');
        el.classList.remove('is-on');
        el.pause();
      }

      // plays a clip from its first frame on top of the stack and resolves when it ends. No "wait until buffered"
      // step: iOS ignores preload and never reports canplaythrough before play(), which stalled every swap.
      // The clip only shows once it is really playing; until then the current still stays on screen.
      // fadeIn: the clip eases in over what is under it (fade = ~90% of the clip); rate: playback speed
      play(video, onStart, fadeIn = false, rate = 1) {
        if (!video) return Promise.resolve();
        if (!video.src) video.src = this.hd ? video.dataset.hd : video.dataset.sd;
        video.defaultPlaybackRate = rate;
        video.playbackRate = rate;
        video.classList.toggle('is-instant', !fadeIn);
        video.classList.toggle('is-fading', fadeIn);
        video.style.zIndex = ++this.z;
        try {
          video.currentTime = 0;
        } catch (e) {}
        return new Promise((resolve) => {
          let guard;
          const finish = () => {
            clearTimeout(guard);
            video.removeEventListener('playing', started);
            video.removeEventListener('ended', finish);
            resolve();
          };
          const started = () => {
            if (onStart) onStart();
            const seconds = (video.duration || 0.7) / rate;
            if (fadeIn) this.style.setProperty('--army-color-fade', `${(seconds * 0.9).toFixed(2)}s`);
            video.classList.add('is-on');
            clearTimeout(guard);
            guard = setTimeout(finish, (seconds + 1.5) * 1000);
          };
          // nothing ever plays (offline, blocked): give up after 8 s
          guard = setTimeout(finish, 8000);
          video.addEventListener('playing', started, { once: true });
          video.addEventListener('ended', finish);
          video.play().catch(finish);
        });
      }
    }

    customElements.define('army-select', ArmySelect);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["arsenal-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('arsenal-hero')) {
    class ArsenalHero extends HTMLElement {
      connectedCallback() {
        this.pointerType = 'mouse';
        this.attractIndex = -1;
        this.zones = [...this.querySelectorAll('[data-arsenal-hit]')].map((hit) => hit.dataset.zone);
        this.canAttract =
          this.hasAttribute('data-attract') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        this.querySelectorAll('[data-arsenal-hit]').forEach((hit) => {
          const zone = hit.dataset.zone;
          hit.addEventListener('pointerdown', (event) => {
            this.pointerType = event.pointerType;
          });
          hit.addEventListener('pointerenter', (event) => {
            if (event.pointerType !== 'mouse') return;
            this.hoveredZone = zone;
            this.hoverZone(zone);
          });
          hit.addEventListener('pointerleave', (event) => {
            if (event.pointerType !== 'mouse') return;
            if (this.hoveredZone === zone) this.hoveredZone = null;
            if (this.pendingZone === zone) this.cancelPending();
            this.deactivateSoon();
          });
          hit.addEventListener('focus', () => {
            this.stopAttract(true);
            this.activate(zone);
          });
          hit.addEventListener('blur', () => this.activate(this.pinned || null));
          // touch: first tap selects the part, second tap opens its collection
          hit.addEventListener('click', (event) => {
            if (this.pointerType !== 'mouse' && this.active !== zone) {
              event.preventDefault();
              this.activate(zone);
            }
          });
        });

        this.setupWheel();

        this.querySelectorAll('[data-arsenal-label]').forEach((el) => {
          el.addEventListener('pointerenter', (event) => {
            if (event.pointerType !== 'mouse') return;
            this.cancelPending();
            this.activate(el.dataset.zone);
          });
          el.addEventListener('pointerleave', (event) => {
            if (event.pointerType === 'mouse') this.deactivateSoon();
          });
        });

        this.querySelector('.arsenal__stage').addEventListener('click', (event) => {
          if (!event.target.closest('[data-arsenal-hit], [data-arsenal-label]')) this.activate(this.pinned || null);
        });

        // recent pointer positions, used to tell whether the mouse is heading for the open item card
        this.trail = [];
        this.addEventListener('pointermove', (event) => {
          if (event.pointerType !== 'mouse') return;
          this.trail.push({ x: event.clientX, y: event.clientY, t: event.timeStamp });
          if (this.trail.length > 12) this.trail.shift();
          if (this.pendingZone && !this.headingToCard()) this.commitPending();
        });

        // attract mode: pauses while the mouse is over the section, stops for good after a touch
        this.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse') this.stopAttract(false, true);
        });
        this.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'mouse') this.scheduleAttract(3000);
        });
        this.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse') this.stopAttract(true);
        });

        if (this.canAttract && this.zones.length) {
          this.observer = new IntersectionObserver(
            ([entry]) => {
              this.visible = entry.isIntersecting;
              if (this.visible) {
                this.scheduleAttract(800);
              } else {
                this.stopAttract();
              }
            },
            { threshold: 0.4 }
          );
          this.observer.observe(this);
        }
      }

      setupWheel() {
        const track = this.querySelector('[data-arsenal-wheel-track]');
        if (!track || !track.children.length) return;
        const items = [...track.children];
        const wheel = {
          nav: this.querySelector('[data-arsenal-wheel]'),
          track,
          items,
          chips: items.map((item) => item.querySelector('[data-arsenal-chip]')),
          centered: -1,
          target: 0,
          user: false,
        };
        this.wheel = wheel;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // a scroll the visitor started (swipe) selects; a scroll we start to follow the figure doesn't
        const endGestureSoon = (delay) => {
          clearTimeout(wheel.settle);
          wheel.settle = setTimeout(() => {
            wheel.user = false;
            wheel.target = wheel.centered;
          }, delay);
        };
        const gesture = () => {
          wheel.user = true;
          endGestureSoon(300);
        };
        // mouse wheel: one notch = one row (a native notch is ~100px, about two rows, so snap skipped every other chip).
        // A burst of events (smooth-scrolling mice, trackpads) counts as one step unless it pauses or lasts long enough.
        // At either end the event is left alone so the page keeps scrolling.
        wheel.wheelAcc = 0;
        wheel.wheelLastEvent = 0;
        wheel.wheelLastStep = 0;
        track.addEventListener(
          'wheel',
          (event) => {
            if (event.ctrlKey) return;
            const unit = event.deltaMode === 1 ? 40 : event.deltaMode === 2 ? track.clientHeight : 1;
            const dy = event.deltaY * unit;
            if (!dy || Math.abs(dy) < Math.abs(event.deltaX)) return;
            const dir = Math.sign(dy);
            const last = wheel.chips.length - 1;
            if ((dir > 0 && wheel.target >= last) || (dir < 0 && wheel.target <= 0)) return;
            event.preventDefault();
            const now = performance.now();
            const newBurst = now - wheel.wheelLastEvent > 120;
            if (newBurst || Math.sign(wheel.wheelAcc) !== dir) wheel.wheelAcc = 0;
            wheel.wheelAcc += dy;
            wheel.wheelLastEvent = now;
            if (Math.abs(wheel.wheelAcc) < 30) return;
            if (!newBurst && now - wheel.wheelLastStep < 260) return;
            wheel.wheelAcc = 0;
            wheel.wheelLastStep = now;
            const index = wheel.target + dir;
            this.selectFromWheel(index);
            this.scrollWheelTo(index);
          },
          { passive: false }
        );
        track.addEventListener('touchstart', gesture, { passive: true });
        track.addEventListener('pointerdown', gesture);
        track.addEventListener(
          'scroll',
          () => {
            if (!wheel.raf) {
              wheel.raf = requestAnimationFrame(() => {
                wheel.raf = 0;
                this.renderWheel();
              });
            }
            endGestureSoon(160);
          },
          { passive: true }
        );

        // click / tap a neighbour: bring it to the centre; the centred chip is a plain link to its collection
        track.addEventListener('click', (event) => {
          const chip = event.target.closest('[data-arsenal-chip]');
          if (!chip) return;
          const index = Number(chip.dataset.index);
          if (index !== wheel.centered) {
            event.preventDefault();
            this.selectFromWheel(index);
            this.scrollWheelTo(index);
          }
        });

        track.addEventListener('keydown', (event) => {
          const last = wheel.chips.length - 1;
          const next = { ArrowDown: wheel.target + 1, ArrowUp: wheel.target - 1, Home: 0, End: last }[event.key];
          if (next === undefined) return;
          event.preventDefault();
          const index = Math.max(0, Math.min(last, next));
          this.selectFromWheel(index);
          this.scrollWheelTo(index);
        });

        const start = Math.floor((wheel.chips.length - 1) / 2);
        const place = () => {
          this.scrollWheelTo(wheel.centered >= 0 ? wheel.centered : start, 'auto');
          this.renderWheel();
        };
        place();
        window.addEventListener('load', place, { once: true });
        window.addEventListener('resize', place);
      }

      // drum effect: rows tilt, shrink and fade with their distance (in rows) to the centre line
      renderWheel() {
        const wheel = this.wheel;
        const middle = wheel.track.scrollTop + wheel.track.clientHeight / 2;
        const row = wheel.items[0].offsetHeight;
        let best = 0;
        let bestDistance = Infinity;
        wheel.items.forEach((item, index) => {
          const d = (item.offsetTop + row / 2 - middle) / row;
          const a = Math.min(Math.abs(d), 3);
          if (Math.abs(d) < bestDistance) {
            bestDistance = Math.abs(d);
            best = index;
          }
          wheel.chips[index].style.transform = this.reducedMotion
            ? `scale(${(1.08 - a * 0.08).toFixed(3)})`
            : `rotateX(${(-d * 22).toFixed(2)}deg) scale(${(1.1 - a * 0.13).toFixed(3)})`;
          wheel.chips[index].style.opacity = (1 - a * 0.3).toFixed(3);
        });
        if (best === wheel.centered) return;

        const hadFocus = wheel.track.contains(document.activeElement);
        const first = wheel.centered < 0;
        wheel.centered = best;
        wheel.chips.forEach((chip, index) => {
          chip.classList.toggle('is-centered', index === best);
          chip.tabIndex = index === best ? 0 : -1;
          if (index === best) chip.setAttribute('aria-current', 'true');
          else chip.removeAttribute('aria-current');
        });
        if (hadFocus) wheel.chips[best].focus({ preventScroll: true });
        if (!first && !this.reducedMotion) {
          wheel.nav.classList.remove('is-ticked');
          void wheel.nav.offsetWidth;
          wheel.nav.classList.add('is-ticked');
        }
        if (wheel.user) this.selectFromWheel(best);
      }

      // the wheel's choice sticks: the figure falls back to it after a hover elsewhere, attract mode stops
      selectFromWheel(index) {
        const zone = this.wheel.chips[index].dataset.zone;
        this.wheel.target = index;
        this.pinned = zone;
        this.stopAttract(true);
        this.cancelPending();
        this.activate(zone, 'user', false);
      }

      scrollWheelTo(index, behavior) {
        const { track, items } = this.wheel;
        const item = items[index];
        this.wheel.target = index;
        track.scrollTo({
          top: item.offsetTop + item.offsetHeight / 2 - track.clientHeight / 2,
          behavior: behavior || (this.reducedMotion ? 'auto' : 'smooth'),
        });
      }

      // hovering the figure and attract mode turn the wheel too, unless the visitor is spinning it
      syncWheel(zone) {
        const wheel = this.wheel;
        if (!wheel || wheel.user) return;
        const index = wheel.chips.findIndex((chip) => chip.dataset.zone === zone);
        if (index >= 0 && index !== wheel.target) this.scrollWheelTo(index);
      }

      disconnectedCallback() {
        this.stopAttract(true);
        if (this.observer) this.observer.disconnect();
      }

      scheduleAttract(delay) {
        if (!this.canAttract || this.touched || !this.visible) return;
        clearTimeout(this.resumeTimer);
        this.resumeTimer = setTimeout(() => this.startAttract(), delay);
      }

      startAttract() {
        if (this.attractTimer || this.matches(':hover')) return;
        const step = () => {
          this.attractIndex = (this.attractIndex + 1) % this.zones.length;
          this.activate(this.zones[this.attractIndex], 'attract');
        };
        step();
        this.attractTimer = setInterval(step, 1500);
      }

      stopAttract(permanent = false, keepCurrent = false) {
        if (permanent) this.touched = true;
        clearTimeout(this.resumeTimer);
        if (this.attractTimer) {
          clearInterval(this.attractTimer);
          this.attractTimer = null;
          if (this.dataset.mode === 'attract' && !keepCurrent) this.activate(null);
        }
      }

      // "menu aim": while the mouse travels toward the open card, parts crossed on the way don't steal the selection
      hoverZone(zone) {
        if (this.active && this.active !== zone && this.headingToCard()) {
          clearTimeout(this.leaveTimer);
          clearTimeout(this.pendingTimer);
          this.pendingZone = zone;
          this.pendingTimer = setTimeout(() => this.commitPending(), 450);
          return;
        }
        this.cancelPending();
        this.activate(zone);
      }

      commitPending() {
        const zone = this.pendingZone;
        this.cancelPending();
        if (zone && this.hoveredZone === zone) this.activate(zone);
      }

      cancelPending() {
        clearTimeout(this.pendingTimer);
        this.pendingZone = null;
      }

      headingToCard() {
        const card = this.active && this.querySelector(`[data-arsenal-label][data-zone="${this.active}"]`);
        if (!card || !card.offsetParent || this.trail.length < 2) return false;
        const last = this.trail[this.trail.length - 1];
        const from = this.trail.find((point) => last.t - point.t <= 80) || this.trail[0];
        const dx = last.x - from.x;
        const dy = last.y - from.y;
        if (Math.hypot(dx, dy) < 2) return false;
        // does the ray from the pointer along its direction hit the card (with a little margin)?
        const r = card.getBoundingClientRect();
        const pad = 24;
        let tMin = 0;
        let tMax = Infinity;
        for (const [p, d, lo, hi] of [
          [last.x, dx, r.left - pad, r.right + pad],
          [last.y, dy, r.top - pad, r.bottom + pad],
        ]) {
          if (d === 0) {
            if (p < lo || p > hi) return false;
          } else {
            const t1 = (lo - p) / d;
            const t2 = (hi - p) / d;
            tMin = Math.max(tMin, Math.min(t1, t2));
            tMax = Math.min(tMax, Math.max(t1, t2));
          }
        }
        return tMin <= tMax;
      }

      deactivateSoon() {
        clearTimeout(this.leaveTimer);
        const delay = this.headingToCard() ? 700 : 350;
        this.leaveTimer = setTimeout(() => {
          if (this.pendingZone) return;
          // back to the part chosen on the wheel, if any
          this.activate(this.pinned || null);
        }, delay);
      }

      activate(zone, mode = 'user', syncWheel = true) {
        clearTimeout(this.leaveTimer);
        if (zone && syncWheel) this.syncWheel(zone);
        this.active = zone;
        if (zone) {
          this.dataset.active = zone;
          this.dataset.mode = mode;
        } else {
          delete this.dataset.active;
          delete this.dataset.mode;
        }
        this.querySelectorAll('[data-zone]').forEach((el) => {
          el.classList.toggle('is-active', el.dataset.zone === zone);
        });
      }
    }

    customElements.define('arsenal-hero', ArsenalHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dispatch-form"] && !Shopify.designMode) return;
  try {
    
  // add the army picked to the entry tags (army-<handle>)
  document.querySelectorAll('[data-dispatch-army]').forEach((select) => {
    const tags = select.form && select.form.querySelector('[data-dispatch-tags]');
    if (!tags) return;
    const sync = () => {
      tags.value = select.value && select.value !== 'any-army' ? `${tags.dataset.base},army-${select.value}` : tags.dataset.base;
    };
    select.addEventListener('change', sync);
    sync();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["forge-band"] && !Shopify.designMode) return;
  try {
    
  // after a free-bits signup the page reloads at the top: bring the downloads into view
  (() => {
    const done = document.querySelector('.forge-band__downloads');
    if (done && /customer_posted=true/.test(window.location.search)) done.closest('.forge-band__card').scrollIntoView({ block: 'center' });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["forge-form"] && !Shopify.designMode) return;
  try {
    
  // remember the email of the first form so the opt-in step shown after sending is prefilled (also used by
  // sections/showcase-form and sections/dispatch-form, which share this layout)
  document.querySelectorAll('[data-forge-form]').forEach((root) => {
    const email = root.querySelector('[data-forge-email]');
    if (email && email.form) {
      email.form.addEventListener('submit', () => {
        try {
          sessionStorage.setItem('forge-pitch-email', email.value);
        } catch (e) {}
      });
    }
    const optin = root.querySelector('[data-forge-optin-email]');
    if (optin) {
      try {
        optin.value = sessionStorage.getItem('forge-pitch-email') || '';
      } catch (e) {}
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["forge-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('forge-gallery')) {
    class ForgeGallery extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.items = [...this.querySelectorAll('.forge-gallery__item')];

        this.querySelectorAll('.forge-gallery__chip').forEach((chip, _, chips) => {
          chip.addEventListener('click', () => {
            chips.forEach((c) => c.setAttribute('aria-pressed', String(c === chip)));
            const army = chip.dataset.filter;
            this.items.forEach((item) => (item.hidden = Boolean(army) && item.dataset.army !== army));
          });
        });

        this.querySelectorAll('.forge-gallery__open').forEach((button) => button.addEventListener('click', () => this.show(button)));
        this.querySelector('[data-gallery-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
      }

      show(button) {
        const d = button.dataset;
        const img = this.querySelector('[data-gallery-img]');
        img.src = d.full;
        img.alt = button.querySelector('img').alt || d.painter;
        this.querySelector('[data-gallery-painter]').textContent = d.painter;
        this.querySelector('[data-gallery-army]').textContent = d.army;
        const link = this.querySelector('[data-gallery-link]');
        link.hidden = !d.link;
        if (d.link) link.href = d.link;
        const product = this.querySelector('[data-gallery-product]');
        product.hidden = !d.product;
        if (d.product) {
          product.href = d.product;
          product.textContent = `${d.productTitle} →`;
        }
        this.dialog.showModal();
      }
    }

    customElements.define('forge-gallery', ForgeGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["free-bitz"] && !Shopify.designMode) return;
  try {
    
  // in-page offer (STL collections, free-bitz page): after signup the page reloads at the top, bring the downloads into view
  (() => {
    const done = document.querySelector('.free-bitz--inline .free-bitz__downloads');
    if (done && /customer_posted=true/.test(window.location.search)) done.closest('.free-bitz').scrollIntoView({ block: 'center' });
  })();

  if (!customElements.get('free-bitz')) {
    class FreeBitz extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog) return;
        this.querySelectorAll('[data-free-bitz-close]').forEach((b) => b.addEventListener('click', () => this.close()));
        // click on the backdrop closes
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.close();
        });
        this.dialog.addEventListener('close', () => this.snooze());

        // just signed up (or the email was refused): show the result straight away
        if (this.dataset.open === 'true') {
          this.open(true);
          return;
        }
        if (this.snoozed()) return;

        const desktop = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        if (desktop) {
          // exit intent: the pointer leaves through the top of the window, once the visitor has looked around
          setTimeout(() => {
            this.onLeave = (event) => {
              if (!event.relatedTarget && event.clientY <= 0) this.open();
            };
            document.addEventListener('mouseout', this.onLeave);
          }, (parseFloat(this.dataset.delay) || 6) * 1000);
        } else {
          this.timer = setTimeout(() => this.open(), (parseFloat(this.dataset.mobileDelay) || 35) * 1000);
          this.onScroll = () => {
            const max = document.documentElement.scrollHeight - window.innerHeight;
            if (max > 0 && window.scrollY / max > 0.55) this.open();
          };
          window.addEventListener('scroll', this.onScroll, { passive: true });
        }
      }

      disconnectedCallback() {
        this.stop();
      }

      stop() {
        clearTimeout(this.timer);
        if (this.onLeave) document.removeEventListener('mouseout', this.onLeave);
        if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      }

      snoozed() {
        try {
          return Number(localStorage.getItem('free-bitz-snooze') || 0) > Date.now();
        } catch (e) {
          return false;
        }
      }

      snooze() {
        try {
          localStorage.setItem('free-bitz-snooze', String(Date.now() + 14 * 864e5));
        } catch (e) {}
      }

      open(force = false) {
        this.stop();
        if (this.dialog.open) return;
        // never over another open dialog (cart drawer, search, menu)
        if (!force && document.querySelector('dialog[open]')) return;
        this.dialog.showModal();
        this.snooze();
      }

      close() {
        this.dialog.close();
      }
    }

    customElements.define('free-bitz', FreeBitz);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["launch-countdown"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('launch-countdown')) {
    class LaunchCountdown extends HTMLElement {
      connectedCallback() {
        this.target = Date.parse(this.dataset.launch);
        this.values = {};
        this.querySelectorAll('[data-unit]').forEach((el) => (this.values[el.dataset.unit] = el));
        const date = this.querySelector('[data-launch-date]');
        if (date && !Number.isNaN(this.target)) {
          date.textContent = new Date(this.target).toLocaleString(document.documentElement.lang || undefined, {
            weekday: 'long', day: 'numeric', month: 'long', hour: '2-digit', minute: '2-digit', timeZoneName: 'short',
          });
        }
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
        // after a signup the page reloads at the top: bring the confirmation into view
        if (/customer_posted=true/.test(window.location.search)) this.querySelector('.launch__card').scrollIntoView({ block: 'center' });
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      tick() {
        if (Number.isNaN(this.target)) return;
        let left = Math.max(0, Math.floor((this.target - Date.now()) / 1000));
        if (left === 0) {
          clearInterval(this.timer);
          this.querySelector('[data-launch-countdown]').hidden = true;
          this.querySelector('[data-launch-date]').hidden = true;
          this.querySelector('[data-launch-live]').hidden = false;
          return;
        }
        const parts = { days: Math.floor(left / 86400), hours: Math.floor((left % 86400) / 3600), minutes: Math.floor((left % 3600) / 60), seconds: left % 60 };
        Object.entries(parts).forEach(([k, v]) => {
          if (this.values[k]) this.values[k].textContent = String(v).padStart(2, '0');
        });
      }
    }

    customElements.define('launch-countdown', LaunchCountdown);
  }

  } catch(e) { console.error(e); }
})();
})();
